import React, { Component, useEffect, useState, useRef } from "react";
import { instanceOf } from "prop-types";
import { withCookies, Cookies } from 'react-cookie';
import { LoginAdminTOAgentConfirmation} from './axios';
import { useParams } from "react-router-dom";
import {  useDispatch } from 'react-redux';
import { createStore } from "redux";
import { addToCart, clearToCart } from "../redux/actions/actions";


export default function AgentLoginConfirmation() {

  const { id } = useParams();
  const email = atob(id);
  const dispatch = useDispatch();
  useEffect(() => {
    LoginAdminTOAgentConfirmation(email).then(
      (data) => {
        dispatch(clearToCart());
        if (data == 'not_correct') {
          let text = "This is not correct.";
          if (window.confirm(text) == true) {
          }
      } else {
          let Verified = '';
          if (data.verified == 1) {
              Verified = true;
          }
          const dataSearch = {
              first_name: data.first_name,
              last_name: data.last_name,
              email: data.email,
              country_code: data.country_code,
              verified: Verified,
              uid: data.id
          }
          let JsonData = JSON.stringify(dataSearch);
          localStorage.setItem('userDetails', JsonData);
         var base_url = window.location.origin;
         window.location.href = base_url+"/PlanTrips";
         this.setState({ btnloader: false });
      }
      },
      (error) => {}
    );
  
}, []);
    return (
      <div id="login">
      </div>
        );
   
}